import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Dialog, DialogTitle, DialogContent, Button } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface FilesAPIDownModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const FilesAPIDownModal: React.FC<FilesAPIDownModalProps> = ({ isOpen, onClose }) => (
  <Dialog open={isOpen} onClose={onClose} maxWidth="sm">
    {/* Modal title */}
    <DialogTitle>
      <Box display="flex" alignItems="center" gap={1}>
        <InfoOutlinedIcon color="info" />
        <FormattedMessage id="FilesApiDownModal.title" />
      </Box>
    </DialogTitle>

    {/* Main message*/}
    <DialogContent>
      <FormattedMessage id={'FilesApiDownModal.message'} />

      {/* Actions */}
      <Box display="flex" sx={{ marginTop: '1rem' }} gap={2} justifyContent="flex-end">
        <Button onClick={onClose} color="secondary" variant="contained">
          OK
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);

export default FilesAPIDownModal;
